import { render, staticRenderFns } from "./PaymentMethodsInfo.vue?vue&type=template&id=d80d9e1c&scoped=true&"
import script from "./PaymentMethodsInfo.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodsInfo.vue?vue&type=script&lang=js&"
import style0 from "./PaymentMethodsInfo.vue?vue&type=style&index=0&id=d80d9e1c&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d80d9e1c",
  null
  
)

export default component.exports